import { render, staticRenderFns } from "./Abonnement.vue?vue&type=template&id=6f97fa79&scoped=true"
import script from "./Abonnement.vue?vue&type=script&lang=js"
export * from "./Abonnement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f97fa79",
  null
  
)

export default component.exports